import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_PAYMENT_FREQUENCIES } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const payFrequencies = {
  namespaced: true,
  state: buildInitialState({
    payFrequenciesList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setPayFrequencies: (state, payFrequencies) => {
      state.payFrequenciesList = payFrequencies
    }
  },
  actions: {
    getPayFrequencies: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_PAYMENT_FREQUENCIES })
        .then(json => json.data)
        .then(payFrequencies => {
          commit('updateStatus', { status: COMPLETE })
          commit('setPayFrequencies', payFrequencies)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default payFrequencies
